import { showFileAction } from "../../../utils/documents/show-file-action.ts"
import type { Attachment } from "../../Album/types/attachment.types.ts"
import type { ProjectDocument } from "../../Project/types/project-documents.types.ts"
import type { FileItem, FileRights, FileSource } from "../types/file-item.types.ts"

export const fileItemKey = (source: FileSource, id: string) => `${source}:${id}`

export const mapAttachmentToFileItem = (
  attachment: Attachment,
  rights: FileRights
): FileItem => {
  const canEdit = showFileAction({
    file: attachment,
    allowed: rights.editAllowed,
    foreignAllowed: rights.editForeignAllowed,
    currentUserId: rights.currentUserId
  })
  return {
    key: fileItemKey("album-attachment", attachment.id),
    id: attachment.id,
    source: "album-attachment",
    name: attachment.original_filename,
    fileUrl: attachment.file,
    mimeType: attachment.mime_type,
    fileSize: attachment.file_size,
    formattedFileSize: attachment.formatted_file_size,
    createdByName: attachment.created_by_name,
    created: attachment.created,
    updated: attachment.created,
    folderId: attachment.folder ?? null,
    canRename: canEdit,
    canMove: canEdit,
    canDelete: showFileAction({
      file: attachment,
      allowed: rights.deleteAllowed,
      foreignAllowed: rights.deleteForeignAllowed,
      currentUserId: rights.currentUserId
    }),
    raw: attachment
  }
}

// core.ProjectAttachment carries no owner, so its rights are the bare flags
// and there is no rename endpoint at all.
export const mapDocumentToFileItem = (
  document: ProjectDocument,
  rights: FileRights
): FileItem => ({
  key: fileItemKey("document", document.id),
  id: document.id,
  source: "document",
  name: document.file_name,
  fileUrl: document.file,
  fileTypeLabel:
    typeof document.file_type_name === "string"
      ? document.file_type_name
      : undefined,
  createdByName: document.uploaded_by,
  created: document.created,
  updated: document.updated,
  folderId: document.folder ?? null,
  canRename: false,
  canMove: rights.editAllowed,
  canDelete: rights.deleteAllowed,
  raw: document
})
